import { render } from "./ConsultarTemplates.vue?vue&type=template&id=7124a3e6&scoped=true"
import script from "./ConsultarTemplates.vue?vue&type=script&lang=js"
export * from "./ConsultarTemplates.vue?vue&type=script&lang=js"

import "./ConsultarTemplates.vue?vue&type=style&index=0&id=7124a3e6&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7124a3e6"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QCarousel,QCarouselSlide});
